import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'CONTACT_UPDATE',
    smsDelete : 'CONTACT_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        complaint_graph: {},
        complain_by_category_graph: {},
        complain_by_onchol_graph: {},
        complain_by_ward_graph: {},
        wards: [],
        onchols: [],
        summary_list: [],
        complain_list: [],
        dashboard_count: {},

        submitSuccess: false,
        contactLoading: false,
        contactError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_COMPLAINT_GRAPH (state, items) {
            state.complaint_graph = items;
        },

        SET_COMPLAINT_BY_CATEGORY_GRAPH (state, items) {
            state.complain_by_category_graph = items;
        },

        SET_COMPLAINT_BY_ONCHOL_GRAPH (state, items) {
            state.complain_by_onchol_graph = items;
        },

        SET_COMPLAINT_BY_WARD_GRAPH (state, items) {
            state.complain_by_ward_graph = items;
        },

        SET_ONCHOLS (state, item) {
            state.onchols = item;
        },

        SET_WARDS (state, item) {
            state.wards = item;
        },

        SET_SUMMARY_LIST(state, contact) {
            state.summary_list = contact;
        },

        SET_CONTACT(state, contact) {
            state.complain_list = contact;
        },

        SET_COUNT(state, contact) {
            state.dashboard_count = contact;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        CONTACT_LOADING (state, loading) {
            state.contactLoading = loading;
        },

        CONTACT_ERROR (state, hasError) {
            state.contactError = hasError;
        }
    },

    actions: {
        // Fetch all graph data
        async fetchComplaintGraph ({ commit }, payload) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try { 
                let params = new URLSearchParams();
        
                if (payload.onchol) params.append('onchol', payload.onchol);
                if (payload.ward_no) params.append('ward_no', payload.ward_no);
                if (payload.category) params.append('category', payload.category);
                if (payload.range) params.append('range', payload.range);
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                
                let url = V1API.complain_graph + '?' + params.toString();
                let result = await axios.get(url, config);
                const response = result.data

                commit('SET_COMPLAINT_GRAPH', response);
                return response;

            } catch(error) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },

        async fetchComplaintByCategoryGraph ({ commit }, payload) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try { 
                let params = new URLSearchParams();
        
                if (payload.onchol) params.append('onchol', payload.onchol);
                if (payload.ward_no) params.append('ward_no', payload.ward_no);
                if (payload.category) params.append('category', payload.category);
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                
                let url = V1API.complain_graph_by_category + '?' + params.toString();
                let result = await axios.get(url, config);
                const response = result.data

                commit('SET_COMPLAINT_BY_CATEGORY_GRAPH', response.data);
                return response;

            } catch(error) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },

        async fetchComplaintByOncholGraph ({ commit }, payload) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try { 
                let params = new URLSearchParams();
        
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                if (payload.category) params.append('category', payload.category);
                
                let url = V1API.complain_graph_by_onchol + '?' + params.toString();
                let result = await axios.get(url, config);
                const response = result.data

                commit('SET_COMPLAINT_BY_ONCHOL_GRAPH', response.data);
                return response;

            } catch(error) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },
        
        async fetchComplaintByWardGraph ({ commit }, payload) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try { 
                let params = new URLSearchParams();
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                if (payload.category) params.append('category', payload.category);
                
                let url = V1API.complain_graph_by_ward + '?' + params.toString();
                let result = await axios.get(url, config);
                const response = result.data

                commit('SET_COMPLAINT_BY_WARD_GRAPH', response.data);
                return response;

            } catch(error) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },

        getOnchols({ commit }) {
            try {
                let response = axios.get(V1API.get_oncols).then(result => {
                    let response = result.data
                    commit('SET_ONCHOLS', response.data);
                    return response;
                })
                return response
            } catch(error) {
                // commit('CONTACT_ERROR', true);
            } finally {
                // commit('CONTACT_LOADING', false);
            }      
        },

        getWards({ commit }) {
            try {
                let response = axios.get(V1API.get_wards).then(result => {
                    let response = result.data
                    commit('SET_WARDS', response.data);
                    return response;
                })
                return response
            } catch(error) {
                // commit('CONTACT_ERROR', true);
            } finally {
                // commit('CONTACT_LOADING', false);
            }      
        },

        getWardsByOnchol({ commit }, payload) {
            try {
                let response = axios.get(V1API.get_wards + '?onchol=' + payload).then(result => {
                    let response = result.data
                    commit('SET_WARDS', response.data);
                    return response;
                })
                return response
            } catch(error) {
                // commit('CONTACT_ERROR', true);
            } finally {
                // commit('CONTACT_LOADING', false);
            }      
        },

        async fetchCount ({ commit }, payload) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.onchol) params.append('onchol', payload.onchol);
                if (payload.ward_no) params.append('ward_no', payload.ward_no);
                if (payload.status) params.append('status', payload.status);
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                
                let url = V1API.count_list + '?' + params.toString();
                let result = await axios.get(url, config);
                let response = result.data
                commit('SET_COUNT', response.data);
                return response;
            } catch(error) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },

        async filterComplaints ({ commit }, payload) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try { 
                let params = new URLSearchParams();
        
                if (payload.onchol) params.append('onchol', payload.onchol);
                if (payload.ward_no) params.append('ward_no', payload.ward_no);
                if (payload.status) params.append('status', payload.status);
                if (payload.start_date) params.append('start_date', payload.start_date);
                if (payload.end_date) params.append('end_date', payload.end_date);
                
                let url = V1API.complain_list + payload.category + '?' + params.toString();
                let result = await axios.get(url, config);
                const response = result.data

                commit('SET_CONTACT', response.data);
                return response;

            } catch(error) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },

        async updateComplainStatus ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.update_status, {
                    tracking_id: payload.id,
                    status: payload.update_status
                }, config).then(result=>{
                    let data = result.data
                    return data
                });

                // commit('SUBMIT_SUCCESS', true);
                dispatch ('filterComplaints', {category: payload.category})
                return response

            } catch (e) {
                // commit('CONTACT_ERROR', true);
            } finally {
                // commit('CONTACT_LOADING', false);
            }
        },

        async deleteComplain({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.complain_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('filterComplaints', {category: payload.category})
            return response
        },

        async addContact ({commit, dispatch}, payload) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_contact, payload.contact, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchContact')
                return response

            } catch (e) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },

        async updateContact ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.update_contact + payload.id, payload.contact, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchContact')
                return response

            } catch (e) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },

        async fetchOccupancySummary ({ commit }, payload) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.shelter) params.append('shelter', payload.shelter);
                if (payload.current_date) params.append('current_date', payload.current_date);
                
                let url = V1API.occupancy_summary_list + '?' + params.toString();
                let result = await axios.get(url, config);
                const response = result.data

                commit('SET_SUMMARY_LIST', response.data)
            } catch(error) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        }
    },

    getters: {}
}
